var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvenient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48.5,
    fill: "#D5E5EF",
    stroke: "#173372",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0417 40.4375C58.0417 44.2766 52.8384 51.118 50.5535 53.8742C50.0054 54.6125 48.9946 54.6125 48.4465 53.8742C46.1616 51.118 40.9583 44.2766 40.9583 40.4375C40.9583 35.7779 44.7807 32 49.5 32C54.2193 32 58.0417 35.7779 58.0417 40.4375ZM49.5 42.6875C51.0731 42.6875 52.3472 41.4289 52.3472 39.875C52.3472 38.3218 51.0731 37.0625 49.5 37.0625C47.9269 37.0625 46.6528 38.3218 46.6528 39.875C46.6528 41.4289 47.9269 42.6875 49.5 42.6875ZM59.2944 44.6422C59.33 44.5578 59.3656 44.4734 59.4012 44.382L67.6582 41.1195C68.7828 40.6766 70 41.4922 70 42.6875V61.7281C70 62.4172 69.5729 63.0359 68.9252 63.2961L58.6111 67.3672V46.0906C58.8602 45.6055 59.088 45.1273 59.2944 44.6422ZM39.7056 44.6422C39.912 45.1273 40.1398 45.6055 40.3889 46.0906V63.7672L31.3426 67.3461C30.2207 67.7258 29 66.9734 29 65.7781V46.7375C29 46.0484 29.4253 45.3664 30.0741 45.1695L38.7944 41.7242C38.9653 42.7227 39.3141 43.7141 39.7056 44.6422ZM52.333 55.2805C53.3224 54.1203 54.8741 52.1305 56.3333 49.9297V67.4586L42.6667 63.5984V49.9297C44.1259 52.1305 45.6776 54.1203 46.667 55.2805C48.1262 57.1438 50.8738 57.1438 52.333 55.2805Z",
    fill: "#173372"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 36,
    fill: "white",
    transform: "translate(29 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvenient);
export default __webpack_public_path__ + "static/media/convenient.f1338d2ba29f8bc583a031f9da3f664d.svg";
export { ForwardRef as ReactComponent };